import { Flex } from '@mantine/core';
import { StepCard } from 'src/UI/generate-flow/StepCard';
import SelectableItemList from 'src/UI/drawer-flow/SelectableItemList';
import { MeetingNoteStepProps, MeetingNoteTemplateType } from '../types';

const TEMPLATE_TYPE_OPTIONS = [
  {
    id: 'template' as MeetingNoteTemplateType,
    title: 'Use a template',
    description: 'Generate meeting notes using a predefined template',
  },
  {
    id: 'agenda' as MeetingNoteTemplateType,
    title: 'Use an agenda',
    description: 'Generate meeting notes using an uploaded agenda file as the structure',
  },
];

export function NoteStructureStep({ data, setData }: MeetingNoteStepProps) {
  return (
    <Flex direction="column" h="100%" mih={0}>
      <StepCard title="How would you like to structure the meeting note?">
        <SelectableItemList
          items={TEMPLATE_TYPE_OPTIONS}
          selectedItemIds={data.templateType ? [data.templateType] : []}
          setSelectedItemIds={ids => {
            const templateType = (ids[0] as MeetingNoteTemplateType) || undefined;
            setData(prev => ({
              ...prev,
              templateType,
              template: undefined,
              selectedAgendaFileId: undefined,
            }));
          }}
          selectMultiple={false}
        />
      </StepCard>
    </Flex>
  );
}
